<div class="layout-wrapper" id="layoutwrapper" [ngClass]="containerClass">
    <app-header *ngIf="isLoggedIn$ | async"></app-header>
    <div class="main-container content-container">
        <router-outlet></router-outlet>
    </div>
    <app-footer *ngIf="isLoggedIn$ | async"></app-footer>
</div>